export default function(dayOfWeek: string): string {
    switch (dayOfWeek) {
        case 'MONDAY':      return 'Lundi';
        case 'TUESDAY':     return 'Mardi';
        case 'WEDNESDAY':   return 'Mercredi';
        case 'THURSDAY':    return 'Jeudi';
        case 'FRIDAY':      return 'Vendredi';
        case 'SATURDAY':    return 'Samedi';
        case 'SUNDAY':      return 'Dimanche';

        default:            return '';
    }
}